<template>
  <div
    :class="backgroundColor"
    class="main-container position-relative mt-2 user-select-none"
  >
    <b-container
      class="desktop-tab-container position-absolute p-2 d-flex justify-content-center"
      :class="{ 'expanded-tab': isTabActive }"
      fluid
    >
      <b-row
        class="d-flex flex-column justify-content-center align-items-center fill-width"
        :class="{ 'border-dashed-light-grey border-radius-28px': isTabActive }"
        no-gutters
      >
        <b-col cols="7" class="d-flex justify-content-center mt-2">
          <b-img
            :class="{ 'active-box-shadow border-radius-28px': isTabActive }"
            :src="handleImageSource"
            class="rounded-pill"
            width="70px"
            fluid
          />
        </b-col>
        <b-col cols="12" class="d-flex justify-content-center pt-2">
          <span class="font-weight-bold new-title-color">
            {{ handleTitleText }}
          </span>
        </b-col>
        <b-col
          cols="12"
          class="d-flex justify-content-center mt-2 position-absolute bottom-5-percent"
        >
          <svg
            v-if="isTabActive"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="currentColor"
            class="bi bi-arrow-down-short"
            viewBox="0 0 16 16"
            style="stroke: #ccc"
          >
            <path
              fill-rule="evenodd"
              d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"
            />
          </svg>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="py-2">
      <b-row>
        <b-col
          cols="12"
          align-self="center"
          class="d-flex justify-content-center align-items-end second-container pb-2 pt-4"
        >
          <svg
            v-if="!isTabActive"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="currentColor"
            class="bi bi-arrow-up-short"
            viewBox="0 0 16 16"
            style="stroke: #fff"
          >
            <path
              fill-rule="evenodd"
              d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"
            />
          </svg>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DesktopTabContainer",
  props: {
    componentName: String,
  },
  computed: {
    ...mapGetters(["getIsCompName"]),
    isTabActive() {
      return (
        // for tether and tron we must stay active on cryptoGroup
        this.getIsCompName === this.handleComponentName ||
        (["tether", "tron"].includes(this.getIsCompName) &&
          this.handleComponentName === "cryptoGroup") ||
        // for accountToAccount and cardToCard we must stay active on indirectGroup
        (["accountToAccount", "cardToCard"].includes(this.getIsCompName) &&
          this.handleComponentName === "indirectGroup")
      );
    },
    handleComponentName() {
      switch (this.componentName) {
        case "perfectMoney":
        case "perfect-money":
          return "perfectMoney";
        case "ctc":
        case "cardToCard":
          return "cardToCard";
        default:
          return this.componentName;
      }
    },
    handleImageSource() {
      switch (this.componentName) {
        case "shetab":
          return require("@/assets/images/shetab-icon.png");
        case "tether":
          return require("@/assets/images/tether-icon.png");
        case "tron":
          return require("@/assets/images/tron-icon.png");
        case "cryptoGroup":
          return require("@/assets/images/crypto-group.png");

        case "perfectMoney":
        case "perfect-money":
          return require("@/assets/images/perfect-money-icon.png");
        case "ctc":
        case "cardToCard":
          return require("@/assets/images/c2c-icon.png");
        case "shaparak":
          return require("@/assets/images/shaparak-icon.png");
        case "vouchers":
          return require("@/assets/images/vouchers.png");
        case "accountToAccount":
        case "indirectGroup":
          return require("@/assets/images/account-to-account.png");
        default:
          return "";
      }
    },
    backgroundColor() {
      switch (this.componentName) {
        case "shetab":
          return "shetab-background";
        case "cryptoGroup":
        case "tether":
          return "tether-background";
        case "tron":
          return "tron-background";
        case "perfectMoney":
        case "perfect-money":
          return "perfect-money-background";
        case "cardToCard":
        case "ctc":
        case "indirectGroup":
          return "ctc-background";
        case "shaparak":
          return "shaparak-background";
        default:
          return "";
      }
    },
    handleTitleText() {
      switch (this.componentName) {
        case "shetab":
          return this.$translate("shetab");
        case "cryptoGroup":
        case "tether":
          return this.$translate("crypto");
        case "tron":
          return this.$translate("tron");
        case "perfect-money":
        case "perfectMoney":
          return this.$translate("perfectMoney");
        case "ctc":
        case "cardToCard":
          return this.$translate("cardToCard");
        case "shaparak":
          return this.$translate("shaparak");
        case "accountToAccount":
          return this.$translate("accountToAccount");
        case "indirectGroup":
          return this.$translate("indirect");
        case "vouchers":
          return this.$translate("vouchers");
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped>
.active-box-shadow {
  box-shadow: #eaeaea 0 0 0 6px;
}
.expanded-tab {
  height: 105% !important;
  transition: 250ms ease-in-out !important; /* Adjust the duration and timing function as needed */
}
.border-radius-28px {
  border-radius: 28px;
}
.desktop-tab-container {
  background: #fff;
  border-radius: 28px;
  box-shadow: 0 10px 30px 0 rgba(43, 55, 86, 0.06);
  height: 80%;
  top: -5%;
  transition: 250ms ease-in-out !important; /* Adjust the duration and timing function as needed */
}
.main-container {
  border-radius: 28px;
}
.second-container {
  border-radius: 28px;
  border: 1px dashed #fff;
  box-shadow: 0px 10px 30px 0px rgba(43, 55, 86, 0.06);
  min-height: 23vh;
  max-height: 28vh;
}
@media screen and (max-height: 600px) and (min-width: 1100px) {
  .second-container {
    min-height: 38vh;
    max-height: 42vh;
  }

  @media screen and (max-height: 450px) {
    .second-container {
      min-height: 42vh;
      max-height: 46vh;
    }
  }
}
.perfect-money-background {
  background: #ffc8c0;
}
.ctc-background {
  background: #d2d4ff;
}
.tether-background {
  background: #cee8de;
}
.shaparak-background {
  background: #fdd6ee;
}
.shetab-background {
  background: #6db6fe;
}
.tron-background {
  background: #ff0000;
}
.bottom-5-percent {
  bottom: 5%;
}
</style>
